import PropTypes from "prop-types";

import Logo from "../../components/Logo";
import NoMatchCard from "../../components/NoMatchCard";

import "./nomatch.scss";

function NoMatch({ subtitle, description }) {
  return (
    <>
      <header>
        <h1>
          <Logo />
          <div className="logotype">Customized SMA Platform Portal</div>
        </h1>
      </header>
      <main className="page__section">
        <NoMatchCard subtitle={subtitle} description={description} />
      </main>
    </>
  );
}

NoMatch.propTypes = {
  subtitle: PropTypes.string,
  description: PropTypes.node,
};

export default NoMatch;
